import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'
import AssignedComissionList from '../components/AssignedComissionList'
import { fetchCustomer, blockCustomer } from '../actions/customers'

import '../styles/CustomerDetailsView.css'
import { currencySymbol } from '../utils/currency';

const TABS = [
  { key: 'general',  label: 'General',       icon: 'fa-user' },
  { key: 'location', label: 'Ubicación',     icon: 'fa-map-marker-alt' },
  { key: 'config',   label: 'Configuración', icon: 'fa-sliders-h' },
  { key: 'billing',  label: 'Facturación',   icon: 'fa-file-invoice-dollar' },
  { key: 'business', label: 'Negocio',       icon: 'fa-briefcase' },
  { key: 'sap',      label: 'SAP',           icon: 'fa-industry' },
  { key: 'articles', label: 'Artículos',     icon: 'fa-shopping-cart' },
]

class CustomerDetailsView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'general',
    }
  }

  componentDidMount() {
    this.props.fetchCustomer(this.props.match.params.id)
  }

  getSAPModel(model) {
    switch (model) {
      case 'VC':
        return 'VENTAS CONTADO (Punto de Venta)'
      case 'CV':
        return 'COMISION VENTA (Solicitud Factura)'
      default:
        return model || '—'
    }
  }

  renderInfoRows(rows) {
    return rows.map(({ label, icon, value }) => (
      <div className="info-row" key={label}>
        <div className="info-label"><i className={`fas ${icon} mr-2`}></i>{label}</div>
        <div className="info-value">{value || '—'}</div>
      </div>
    ))
  }

  render() {
    const { customer, error, loading, role } = this.props
    const { activeTab } = this.state

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!customer || loading) {
      return <LoadingProgress />
    }

    return (
      <div className="customer-details-view">
        {/* Header */}
        <div className="cust-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-user mr-3"></i>
                {customer.Fullname}
              </h1>
              <div className="cust-header-meta">
                <span className="cust-meta-badge type">{customer.Type}</span>
                {customer.Category && <span className="cust-meta-badge category">{customer.Category}</span>}
                {customer.isBlocked && <span className="cust-meta-badge blocked"><i className="fas fa-ban mr-1"></i>Bloqueado</span>}
              </div>
            </div>
            {role === 'ADMIN' && (
              <div className="header-actions">
                <Link to={`/customers/${customer._id}/edit`} className="cust-admin-btn primary">
                  <i className="fas fa-edit"></i><span>Editar</span>
                </Link>
                <button
                  className={`cust-admin-btn ${customer.isBlocked ? 'success' : 'danger'}`}
                  onClick={() => this.props.blockCustomer(customer._id)}
                >
                  <i className={`fas ${customer.isBlocked ? 'fa-lock-open' : 'fa-ban'}`}></i>
                  <span>{customer.isBlocked ? 'Desbloquear' : 'Bloquear'}</span>
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Tab Nav */}
        <div className="cust-tab-nav">
          {TABS.map(tab => (
            <button
              key={tab.key}
              className={`cust-tab-btn${activeTab === tab.key ? ' active' : ''}`}
              onClick={() => this.setState({ activeTab: tab.key })}
            >
              <i className={`fas ${tab.icon} mr-2`}></i>
              {tab.label}
            </button>
          ))}
        </div>

        {/* Tab Panels */}
        <div className="cust-tab-content">

          {/* GENERAL */}
          {activeTab === 'general' && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-user mr-2"></i>Identificación
                </div>
                <div className="card-body-custom">
                  {this.renderInfoRows([
                    { label: 'Nombre completo', icon: 'fa-user', value: customer.Fullname },
                    { label: 'Persona de contacto', icon: 'fa-user-tie', value: customer.Contact_person },
                    { label: 'E-Mail', icon: 'fa-envelope', value: customer.Email },
                    { label: 'Teléfono 1', icon: 'fa-phone', value: customer.Phone },
                    { label: 'Teléfono 2', icon: 'fa-phone-alt', value: customer.Phone2 },
                    { label: 'Fax', icon: 'fa-fax', value: customer.Fax },
                    { label: 'Web', icon: 'fa-globe', value: customer.Web },
                  ])}
                </div>
              </div>
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-info-circle mr-2"></i>Información adicional
                </div>
                <div className="card-body-custom">
                  {this.renderInfoRows([
                    { label: 'Idioma', icon: 'fa-language', value: customer.Language },
                    { label: 'Moneda del panel', icon: 'fa-coins', value: customer.Currency },
                    { label: 'Grupo', icon: 'fa-users', value: customer.Group },
                    { label: 'Email de incidencias', icon: 'fa-envelope-open-text', value: customer.IncidencesEmail },
                    { label: 'ID Externo', icon: 'fa-external-link-alt', value: customer.ExternalId },
                    { label: 'Notas', icon: 'fa-sticky-note', value: customer.Notes },
                  ])}
                </div>
              </div>
            </div>
          )}

          {/* LOCATION */}
          {activeTab === 'location' && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-map-marker-alt mr-2"></i>Ubicación
                </div>
                <div className="card-body-custom">
                  {this.renderInfoRows([
                    { label: 'Dirección', icon: 'fa-map-marker-alt', value: customer.Address },
                    { label: 'Código Postal', icon: 'fa-mail-bulk', value: customer.PostalCode },
                    { label: 'Ciudad', icon: 'fa-city', value: customer.City },
                    { label: 'Provincia', icon: 'fa-map', value: customer.Province },
                    { label: 'País', icon: 'fa-globe', value: customer.Country },
                  ])}
                </div>
              </div>
            </div>
          )}

          {/* CONFIG */}
          {activeTab === 'config' && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-sliders-h mr-2"></i>Configuración
                </div>
                <div className="card-body-custom">
                  {this.renderInfoRows([
                    { label: 'Tipo', icon: 'fa-tag', value: customer.Type },
                    { label: 'Categoría', icon: 'fa-layer-group', value: customer.Category },
                    { label: 'Última edición', icon: 'fa-user-edit', value: customer.Executor },
                  ])}
                </div>
              </div>
            </div>
          )}

          {/* BILLING */}
          {activeTab === 'billing' && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-file-invoice-dollar mr-2"></i>Facturación
                </div>
                <div className="card-body-custom">
                  {this.renderInfoRows([
                    { label: 'NIF/CIF', icon: 'fa-id-card', value: customer.Invoice_taxid },
                    { label: 'IVA aplicable (%)', icon: 'fa-percent', value: customer.Invoice_tax },
                    { label: 'Razón social', icon: 'fa-building', value: customer.Social_name },
                    { label: 'Dirección de facturación', icon: 'fa-map-marker-alt', value: customer.Invoice_address },
                  ])}
                </div>
              </div>
            </div>
          )}

          {/* BUSINESS */}
          {activeTab === 'business' && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-briefcase mr-2"></i>Modelo de Negocio
                </div>
                <div className="card-body-custom">
                  {this.renderInfoRows([
                    { label: 'Modelo', icon: 'fa-cogs', value: customer.BusinessModel },
                    { label: 'Alquiler Anual', icon: 'fa-euro-sign', value: customer.SpaceRentalAlquiler ? `${customer.SpaceRentalAlquiler} ${currencySymbol()}` : null },
                  ])}
                </div>
              </div>
            </div>
          )}

          {/* SAP */}
          {activeTab === 'sap' && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-industry mr-2"></i>SAP
                </div>
                <div className="card-body-custom">
                  {this.renderInfoRows([
                    { label: 'Modelo', icon: 'fa-cogs', value: this.getSAPModel(customer.SAP?.Model) },
                    { label: 'CompanyID', icon: 'fa-building', value: customer.SAP?.CompanyID },
                    { label: 'CountryCode', icon: 'fa-globe', value: customer.SAP?.CountryCode },
                    { label: 'ClientID', icon: 'fa-user', value: customer.SAP?.ClientID },
                    { label: 'SiteID', icon: 'fa-map-marker-alt', value: customer.SAP?.SiteID },
                    { label: 'TaxCountryCode', icon: 'fa-flag', value: customer.SAP?.TaxCountryCode },
                    { label: 'TaxationCharacteristicsCode', icon: 'fa-calculator', value: customer.SAP?.TaxationCharacteristicsCode },
                    { label: 'InventoryManagedLocationID', icon: 'fa-warehouse', value: customer.SAP?.InventoryManagedLocationID },
                    { label: 'LogisticsAreaID', icon: 'fa-truck', value: customer.SAP?.LogisticsAreaID },
                    { label: 'TaxRegionCode', icon: 'fa-map', value: customer.SAP?.TaxRegionCode },
                  ])}
                </div>
              </div>
            </div>
          )}

          {/* ARTICLES */}
          {activeTab === 'articles' && (
            <div className="cust-tab-grid">
              <div className="customer-card">
                <div className="card-header-custom">
                  <i className="fas fa-shopping-cart mr-2"></i>Artículos
                </div>
                <div className="card-body-custom">
                  <AssignedComissionList items={customer.Items} />
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  customer: state.customers.customer,
  loading: state.customers.loading,
  error: state.customers.error,
  role: state.auth.role
})

const mapDispatchToProps = dispatch => ({
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  blockCustomer: bindActionCreators(blockCustomer, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetailsView)
